/* eslint-disable */
const ServiceSVGAnimation = {
  init : function(container){
    this.defaultEase = 'expo.inOut'; // Expo.easeInOut;
    
    this.container = container;
    this.svg = {
      $el : jQuery(this.container).find('svg')
    };
    
    this.svg.$el.css('overflow', 'visible');
    
    this.hideTextInSvg();
  },
  hideTextInSvg : function(){
    jQuery('#Infowagen_Text, #Ticketwagen_Text, #Unwetter_Text_an, #Veranstalter_Text, #Presseinformationen_Text, #Informationen_Text').hide();
  },
  animateInfowagen : function(){
    this.svg.infowagen = {};
    this.svg.infowagen.$group = this.svg.$el.find('#Infowagen');
    const tlInfowagenMaster = gsap.timeline({
      paused : true,
      force3D : true
    });

    return tlInfowagenMaster
      .add(this.animateInfowagenSonne(), 0)    
      .add(this.animateInfowagenVogel(), 0)
      .add(this.animateInfowagenIcon(), 2);
  },
  animateInfowagenIcon : function(){
    this.svg.infowagen.icon = {};
    this.svg.infowagen.icon.$el = this.svg.$el.find('#Infoschild');

    const duration = 1,
      tlInfowagenIcon = gsap.timeline({
        repeat: -1,
        repeatDelay : 10
      });
    
    tlInfowagenIcon
      .to(this.svg.infowagen.icon.$el, duration / 4, {y:-50, ease:'Power2.easeOut'}, 0)
      .to(this.svg.infowagen.icon.$el, duration / 2, {y:0, ease:'Bounce.easeOut', delay:duration / 4}, 0);

    return tlInfowagenIcon;
  },
  animateInfowagenVogel : function(){
		const self = this;

    this.svg.infowagen.vogel = {
      $group : this.svg.$el.find('#Vogel_an-2'),
      $fluegelHinten : this.svg.$el.find('#Vogel_Flügel_hinten_an'),
      $fluegelVorne : this.svg.$el.find('#Vogel_Flügel_vorne_an'),
      $auge : this.svg.$el.find('#Vogel_Auge')
    };    

		const tlBirdMaster = gsap.timeline( {
				// repeat: -1,
				onStartParams: ['{self}'],
				onStart( tl ){
					tl.is_end = false;
				},
				onUpdateParams: ['{self}'], 
				onUpdate( tl ){

				},
				onCompleteParams: ['{self}'],
				onComplete( tl ){
					tl.is_end = true;
				},
				onReverseCompleteParams: ['{self}'],
				onReverseComplete( tl ){
					tl.is_end = false;
        },
        force3D : true
			} ); 
    
    
		gsap.set( this.svg.infowagen.vogel.$fluegelHinten, {
			transformOrigin: '50% 50%',
			scaleY: 1
		} );
		gsap.set( this.svg.infowagen.vogel.$fluegelVorne, {
			transformOrigin: '75% 50%',
			scaleY: 1
		} );

		const tlFluegel = gsap.timeline( { 
			repeat: -1,
      yoyo: true,
      force3D : true
    } );
    
		tlFluegel.to( this.svg.infowagen.vogel.$fluegelHinten, 0.15, {
			scaleY: 0.5,
		} ).to( this.svg.infowagen.vogel.$fluegelVorne, 0.15, {
			scaleY: 0.5,
			rotation: -22
		}, '-=0.16' );
    
    const tlBirdAuge = gsap.timeline({
      repeat: -1,
      repeatDelay : 8,
      force3D : true     
    });
    tlBirdAuge.to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }).to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 1
    }).to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }, '+=0.1').to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 1
    }).to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }, '+=3.5').to(this.svg.infowagen.vogel.$auge, 0.15, {
      scaleY : 1
    });

    gsap.set(this.svg.infowagen.vogel.$group, {
      rotation : 10
    });
    
    const tlBirdMotion = gsap.timeline({
      repeat: -1,
      repeatDelay: 5,
      force3D : true
    });   
    
    tlBirdMotion.to(this.svg.infowagen.vogel.$group, 5, {
      y : -32,
      ease: this.defaultEase
    }).to(this.svg.infowagen.vogel.$group, 5, {
      y : 0,
      ease: this.defaultEase
    });

    return tlBirdMaster.add(tlFluegel).add(tlBirdAuge).add(tlBirdMotion);
  },
  animateInfowagenSonne : function(){
    const tlSonneMaster = gsap.timeline();

    this.svg.infowagen.sonne = {
      $group : this.svg.$el.find('#Sonne_an'),
      $stahlen : this.svg.$el.find('#Sonne_Strahlen_an'),
    };
    
    const tlSunRotate = gsap.timeline({
      repeat : -1,
      force3D : true
    });
    tlSunRotate.to(this.svg.infowagen.sonne.$group, 130, {
      rotation : -360,
      transformOrigin : '50% 50%',
      ease : 'power0.none'// Power0.easeNone
    });
    
    const tlSunStrahlen = gsap.timeline({
      repeat : -1,
      repeatDelay : 5,
      force3D : true
    });
    tlSunStrahlen.to(this.svg.infowagen.sonne.$stahlen, 0.3, {
      scale : 1.03,
      transformOrigin: '50% 50%'
    }).to(this.svg.infowagen.sonne.$stahlen, 0.3, {
      scale : 0.99,
      transformOrigin: '50% 50%'
    }).to(this.svg.infowagen.sonne.$stahlen, 0.3, {
      scale : 1.00,
      transformOrigin: '50% 50%'
    });

    return tlSonneMaster.add(tlSunRotate, 0).add(tlSunStrahlen, 0);
  },
  animateInfowagenWagen : function(){
    this.svg.infowagen.wagen = {};
    this.svg.infowagen.wagen.$group = this.svg.$el.find('#Infowagen_an');
    this.svg.infowagen.wagen.$sign = this.svg.$el.find('#Infoschild');
    this.svg.infowagen.wagen.$ground = this.svg.$el.find('#Infowagen_Loch_an');
    
    const tlWagen = gsap.timeline({
      force3D : true
    });
    
    tlWagen.from(this.svg.infowagen.wagen.$ground, 1, {
      transformOrigin : '50% 50%',
      scale : 0
    }).from(this.svg.infowagen.wagen.$group.find('> *:not(ellipse):not(#Infoschild)'), 1, {
      autoAlpha : 0,
      y : -100,
      ease : 'Back.easeOut.config(1.7)'
    }, '-=0.6').from(this.svg.infowagen.wagen.$sign, 1, {
      autoAlpha : 0,
      y : -50,
      ease : 'Back.easeOut.config(1.7)'     
    }, '-=0.8');

    return tlWagen;
  },
  animateInfowagenWolken : function(){
    this.svg.infowagen.wolken = {};
    this.svg.infowagen.wolken.$links = jQuery(this.svg.$el).find('#Wolke-6');
    this.svg.infowagen.wolken.$mitte = jQuery(this.svg.$el).find('#Wolke-7');
    this.svg.infowagen.wolken.$rechts = jQuery(this.svg.$el).find('#Wolke-8');
    
    gsap.set(
      [
        this.svg.infowagen.wolken.$links,
        this.svg.infowagen.wolken.$mitte,
        this.svg.infowagen.wolken.$rechts
      ], {
        transformOrigin : '50% 50%' 
      }
    );
    
  },
  animateTicketservice : function(){
    this.svg.ticketservice = {};
    this.svg.ticketservice.$group = this.svg.$el.find('#Ticketservice');
    
    this.svg.ticketservice.haus = {};
    this.svg.ticketservice.haus.$el = this.svg.$el.find('#Tickethäuschen');

    this.svg.ticketservice.schlange = {};
    this.svg.ticketservice.schlange.$path = this.svg.$el.find('#Ticketschlange_an-3 path');

    const tlTicketserviceMaster = gsap.timeline({
      force3D : true,
      paused : true
    });

    return tlTicketserviceMaster
      .add(this.animateTicketserviceBird(), 0);
  },
  animateTicketserviceTicketFlight : function(){
    const self = this;
    
    this.svg.ticketservice.ticket = {};
    this.svg.ticketservice.ticket.$el = this.svg.$el.find('#Ticket_Original');
    this.svg.ticketservice.ticket.$toEl = this.svg.$el.find('#Tickets_an');
    
    /*
    gsap.set(this.svg.ticketservice.ticket.$el, {
      autoAlpha : 0,
      x : 25
    });
    */
    gsap.set(this.svg.ticketservice.ticket.$toEl, {
      autoAlpha : 0
    });
    
    const tlTicketHover = gsap.timeline({
      repeat: -1,
      // repeatDelay: 1,
      yoyo : true,
      paused : true,
      onStartParams: ['{self}'],
      onStart( tl ){
        
      },
      force3D : true      
    });
    tlTicketHover.to(this.svg.ticketservice.ticket.$el, 4, {
      y : '-=17',
      ease : 'Power1.easeInOut'
    });

    const tlTicketFlight = gsap.timeline({
      force3D : true,
      onComplete: function(){
        tlTicketHover.play();
      },
      onReverseComplete: function() {
        tlTicketHover.pause();
        tlTicketHover.stop();
        tlTicketHover.progress(0);
      }      
    });
    
    // MorphSVGPlugin.pathDataToBezier('M673.93,1164.36C816.86,1331.66,967,1252.21,967,1252.21', 

    const ticketFlightPath = {
      path: 'M673.93,1164.36C816.86,1331.66,967,1252.21,967,1252.21',
      align : this.svg.ticketservice.ticket.$el.selector,
      alignOrigin: [0.5, 0.5],
      autoRotate: true,
    };
    tlTicketFlight.from(this.svg.ticketservice.ticket.$el, 0.3, {
      autoAlpha : 0
    }, 0).from(this.svg.ticketservice.ticket.$el, 2.5, {
      transformOrigin : '50% 50%',
      motionPath: ticketFlightPath,
      ease : this.defaultEase,
    }, 0.1).to(this.svg.ticketservice.ticket.$el, 0.4, {
      scaleX : 1.4,
      ease : 'Power0.easeNone'
    }, 0.5).to(this.svg.ticketservice.ticket.$el, 0.35, {
      scaleX : 1,
      ease : 'Power0.easeNone'
    }, 1.5)
    .to(this.svg.ticketservice.ticket.$el, 1, {
      scaleY: -1
    }, 0.65);

    return tlTicketFlight;
  },
  animateTicketserviceHaus : function(){
    const tlHausMaster = gsap.timeline({
      force3D : true
    });

    tlHausMaster.from(this.svg.ticketservice.haus.$el, 0.5, {
      ease : 'Bounce.easeOut',
      autoAlpha : 0,
      y : -200
    });

    return tlHausMaster;
  },
  animateTicketserviceBird : function(){
    this.svg.ticketservice.vogel = {};
    this.svg.ticketservice.vogel.$group = this.svg.$el.find('#Vogel_an');
    this.svg.ticketservice.vogel.$fluegelHinten = this.svg.$el.find('#Flügel_hinten');
    this.svg.ticketservice.vogel.$fluegelVorne = this.svg.$el.find('#Flügel_vorne');
    this.svg.ticketservice.vogel.$auge = this.svg.ticketservice.vogel.$group.find('#Auge');
    
    const tlTicketserviceBirdMaster = gsap.timeline({
      force3D : true
    });

    gsap.set( this.svg.ticketservice.vogel.$fluegelHinten, {
			transformOrigin: '50% 50%',
			scaleY: 1
		} );
		
    gsap.set( this.svg.ticketservice.vogel.$fluegelVorne, {
			transformOrigin: '75% 50%',
			scaleY: 1
		} );

		const tlFluegel = gsap.timeline( { 
			repeat: -1,
      yoyo: true,
      force3D : true
    } );
    
		tlFluegel.to( this.svg.ticketservice.vogel.$fluegelHinten, 0.15, {
			scaleY: 0.5,
		} );
		tlFluegel.to( this.svg.ticketservice.vogel.$fluegelVorne, 0.15, {
      transformOrigin : 'left top',
			rotation: 30
		}, '-=0.16' );
    
    const tlBirdAuge = gsap.timeline({
      repeat: -1,
      repeatDelay : 8,
      force3D : true      
    });

    tlBirdAuge.to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }).to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 1
    }).to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }, '+=0.1').to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 1
    }).to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 0,
      transformOrigin: '50% 50%'
    }, '+=3.5').to(this.svg.ticketservice.vogel.$auge, 0.15, {
      scaleY : 1
    });  

    return tlTicketserviceBirdMaster.add(tlFluegel, 0).add(tlBirdAuge, 0);
  },
  animateTicketserviceBirdPath : function(){
    gsap.set(this.svg.ticketservice.vogel.$group, {
      rotation : -10
    });
    
    const tlBirdMotion = gsap.timeline({
      force3D : true
    });
    
    tlBirdMotion.fromTo(this.svg.ticketservice.vogel.$group, 10, {
      x : 600
    }, {
      x : -1500,
      ease : 'Power0.easeNone'
    });

    return tlBirdMotion;
  },
  animateTicketserviceTicketschlangePath : function(){

    const tlTicketschlangeMotion = gsap.timeline({
      force3D : true
    }); 
    
    gsap.set(this.svg.ticketservice.schlange.$path, {
      stroke : 'white',
      fill: 'transparent'
    });

    tlTicketschlangeMotion.fromTo(this.svg.ticketservice.schlange.$path, 10, {
      drawSVG: "0%"
    }, {
      drawSVG: "100%",
      ease : 'Power0.easeNone'
    });
    
    return tlTicketschlangeMotion;
  },

  /**
   * Unwetterinfos
   */
  animateUnwetter : function(){
    this.svg.unwetter = {};
    this.svg.unwetter.$group = this.svg.$el.find('#Unwetterinformationen');
    this.svg.unwetter.$regen = this.svg.unwetter.$group.find('#Regentropen_an');
    this.svg.unwetter.$tropfen = this.svg.unwetter.$group.find('line');

    const tlUnwetterMaster = gsap.timeline({
      force3D : true,
      paused : true
    });    
    
    return tlUnwetterMaster.add(this.animateUnwetterRegen(), 0).add(this.animateUnwetterBlitz(), 0);
  },
  animateUnwetterBlitz : function(){
    const tlBlitzMaster = gsap.timeline({
      force3D: true,
      repeat: -1,
      repeatDelay : 4,
    });
    const $blitz = this.svg.unwetter.$group.find('> path:first');
    tlBlitzMaster.set($blitz, { 
      autoAlpha : 0,
    }).to($blitz, 0.8, {
      autoAlpha : 1,
      y : 10,
      x : -10,
      /*
      ease: RoughEase.ease.config({
        template : 'Power0.easeNone',
        strength : 0.8,
        points : 15,
        taper : "none",
        randomize : true,
        clamp : true
      })
      */
     ease: 'power2.out',
    }).to($blitz, 1, {
      autoAlpha : 0,
      y : 0,
      x : 0,
      ease: 'Power1.easeOut'
    });

    return tlBlitzMaster;
  },
  animateUnwetterRegen : function(){
    const tlUnwetterRegen = gsap.timeline({
      repeat : -1,
      onStart : function(){
  
      },
      onComplete : function(){
      }
    });

    const duration = 1;
    const easeUnwetterTl1 = 'power0.none'; // Power0.easeNone;
    const easeUnwetterTl2 = 'power2.out'; // Power2.easeOut;
    // this.svg.unwetter.$tropfen.each(function(el, i){
    // const $tropfen = jQuery(el);

    tlUnwetterRegen
    .set(this.svg.unwetter.$tropfen, {
      drawSVG : '0%',
      autoAlpha : 0,
      transformOrigin : '50% 50%'
    })
    .to(this.svg.unwetter.$tropfen.filter(':nth-child(even)'), duration, {
      // scaleY : 1.5,
      y : '+=2.5',
      x : '+=2.5',
      drawSVG : '100%',
      autoAlpha: 1,
      ease : easeUnwetterTl2
    }, 0)
    .to(this.svg.unwetter.$tropfen.filter(':nth-child(even)'), duration, {
      y : '+=2.5',
      x : '+=2.5',        
      // drawSVG : '0%',
      autoAlpha: 0,
      ease : 'Power0.easeNone'
    })
    .to(this.svg.unwetter.$tropfen.filter(':nth-child(odd)'), duration, {
      // scaleY : 1.5,
      y : '+=2.5',
      x : '+=2.5',
      drawSVG : '140%',
      autoAlpha: 1,
      ease : easeUnwetterTl2
    }, duration * 0.15)
    .to(this.svg.unwetter.$tropfen.filter(':nth-child(odd)'), duration, {
      y : '+=2.5',
      x : '+=2.5',
      // drawSVG : '0%',
      autoAlpha: 0,
      ease : 'Power0.easeNone'
    });      
  // });

    return tlUnwetterRegen;
  },
  animateInfo : function(){

    this.svg.info = {};
    this.svg.info.$group = this.svg.$el.find('#Informationen');
    this.svg.info.icons = {};
    this.svg.info.icons.$audio = this.svg.info.$group.find('#Icons_01');
    this.svg.info.icons.$flaschen = this.svg.info.$group.find('#Icons_02');
    this.svg.info.icons.$zeit = this.svg.info.$group.find('#Icons_03');
    this.svg.info.icons.$brief = this.svg.info.$group.find('#Brief');
    this.svg.info.icons.$absperrung = this.svg.info.$group.find('#Absperrung');

    const tlInfoMaster = gsap.timeline({
      paused : true,
      repeat : -1,
    });

    return tlInfoMaster.add(this.animateInfoIconsRepeat(), 0);
  },

  animateInfoIcons : function(){
    const tlInfoIconsMaster = gsap.timeline({
      // paused : true
    });

    const tlInfoIcon = gsap.timeline({

    });

    const $icons = this.svg.info.$group.find('#Icons_01, #Icons_02, #Icons_03, #Brief');

    tlInfoIcon.from( $icons, 1, {
      autoAlpha : 0
    }, 0);

    return tlInfoIconsMaster.add(tlInfoIcon, 0);
  },

  animateInfoIconsRepeat : function(){

    const tlIconMaster = gsap.timeline({
      repeat : -1
    });

    const tlIconAudio = gsap.timeline({
      repeat : -1,
      repeatDelay : 4,
    });
    const tlIconFlaschen = gsap.timeline({
      repeat : -1
    });
    const tlIconZeit = gsap.timeline({});
    const tlIconBrief = gsap.timeline({});
    const tlIconAbsperrung = gsap.timeline({});

    // Kamera
    /*
    tlIconAudio.to(this.svg.info.icons.$audio.find('#Kamera_Objektiv'), 0.5, {
      transformOrigin : '50% 50%',
      scale: 1.15
    }).to(this.svg.info.icons.$audio.find('#Kamera_Objektiv'), 0.5, {
      scale: 1
    });
    */

    // Flaschen
    gsap.set(this.svg.info.icons.$flaschen, {
      y : -20
    });
    gsap.set(this.svg.info.icons.$flaschen.find('#Kreuz_02'), {
      x : -40,
      y : -40,
      stroke : "white",
      strokeWidth : 4,
    });
    gsap.set(this.svg.info.icons.$flaschen.find('#Flasche_hinten, #Flasche'), {
      x : 40,
      y : 40
    });

    tlIconFlaschen
    .set(this.svg.info.icons.$flaschen.find('#Kreuz_02'), {
      autoAlpha : 0
    })
    .to(this.svg.info.icons.$flaschen.find('#Flasche_hinten'), 1, {
      transformOrigin : 'center bottom',
      rotation : -10,
      y : '+=10',
      x : '+=10',
    }, 0).to(this.svg.info.icons.$flaschen.find('#Flasche'), 1, {
      transformOrigin : 'center bottom',
      rotation : 10
    }, 0).to(this.svg.info.icons.$flaschen.find('#Flasche_hinten'), 1, {
      transformOrigin : 'center bottom',
      rotation : 0,
      y : '-=10',
      x : '-=10',      
    }, 1).to(this.svg.info.icons.$flaschen.find('#Flasche'), 1, {
      transformOrigin : 'center bottom',
      rotation : 0
    }, 1)
    .to(this.svg.info.icons.$flaschen.find('#Kreuz_02'), 1, {
      autoAlpha : 1
    }).to(this.svg.info.icons.$flaschen.find('#Kreuz_02'), 1, {
      autoAlpha : 0
    }, '+=2.5');

    return tlIconMaster.add(tlIconFlaschen, 0);//.add(tlIconAudio, 0.2);
  },

  animateInfoDrips : function(){
    this.svg.info.$drips = this.svg.info.$group.find('#Textur_Boden').find('#Tex_14, #Tex_15, #Tex_16, #Tex_17, #Tex_18, #Tex_19, #Tex_20');
    const tlInfoDripsMaster = gsap.timeline({
      repeat : -1,
    });

    const duration = 1;
    const easeDripsTl1 = 'power0.none'; // Power0.easeNone;
    const easeDripsTl2 = 'power2.out'; // Power2.easeOut;
    // this.svg.unwetter.$tropfen.each(function(el, i){
    // const $tropfen = jQuery(el);

    tlInfoDripsMaster
    .set(this.svg.info.$drips.filter('#Tex_17'), {
      transformOrigin : '50% 50%',
      scaleY : -1
    })
    .set(this.svg.info.$drips, {
      drawSVG : '0%',
      autoAlpha : 0,
      transformOrigin : '50% 50%'
    })
    .to(this.svg.info.$drips.filter(':nth-child(even)'), duration, {
      // scaleY : 1.5,
      y : '+=2.5',
      x : '+=2.5',
      drawSVG : '100%',
      autoAlpha: 1,
      ease : easeDripsTl2
    }, 0)
    .to(this.svg.info.$drips.filter(':nth-child(even)'), duration, {
      y : '+=2.5',
      x : '+=2.5',        
      // drawSVG : '0%',
      autoAlpha: 0,
      ease : 'Power0.easeNone'
    })
    .to(this.svg.info.$drips.filter(':nth-child(odd)'), duration, {
      // scaleY : 1.5,
      y : '+=2.5',
      x : '+=2.5',
      drawSVG : '140%',
      autoAlpha: 1,
      ease : easeDripsTl2
    }, duration * 0.15)
    .to(this.svg.info.$drips.filter(':nth-child(odd)'), duration, {
      y : '+=2.5',
      x : '+=2.5',
      // drawSVG : '0%',
      autoAlpha: 0,
      ease : 'Power0.easeNone'
    }); 
    
    return tlInfoDripsMaster;
  },

  animatePresse : function(){
    this.svg.presse = {};
    this.svg.presse.$group = this.svg.$el.find('#Veranstalter, #Presseinformationen');

    const tlPresseMaster = gsap.timeline({
      force3D : true,
      repeat : -1
    });

    return tlPresseMaster.add(this.animatePresseSchild(), 0);//.add(this.animatePresseFrauHaare(), 0)
  },
  animatePresseFrauHaare : function(){
    this.svg.presse.$haare = this.svg.presse.$group.find('#Haare path:first');
    
    const tlPresseFrauHaareMaster = gsap.timeline({
      yoyo : true,
      repeat : -1
    });
    const toPath = 'M958.82,4197.11a218.33,218.33,0,0,1-34.44-3.12c-32-4.92-75.8-11.65-86.62-40.12-5.91-15.56.62-30.93,6.39-44.49,5.69-13.37,10.6-24.92,4.54-34.89-1.87-3.08-3.54-4.09-6.29-5.76a40.16,40.16,0,0,1-14.06-13.27c-8.47-12.39-11.42-26-12.4-35.27-.83-7.84-.68-18,1.23-21.48,15.55-28.09-6.25-45.57-10.78-48.79l-4.6-3.27,2.59-5c2.52-4.88,4.93-9.49,6.9-13.25-10.68-1.13-26.6-5.34-36.58-19.57-5.29-4.86-35.71-35.76-18.25-89.24,9-27.66,22.16-49.42,39-64.65,16.64-15,36.57-23,57.63-23,27.13,0,55.51,13,82.07,37.58,43.46,40.23,32.77,90.19,14.75,138.18-8.25,22-5.09,28.36-3.21,32.17a25.24,25.24,0,0,1,1.21,2.72c4.64,13,15.36,19.09,33.11,29.21,7.27,4.15,15.51,8.84,24.74,14.85,15.27,9.93,29.46,22.51,57.74,47.56,24.29,21.52,43.46,38.51,55.52,52,10.06,11.22,19.74,24.48,15.35,37.78-3.31,10-11.81,12.49-24.68,16.24a279,279,0,0,0-40.79,14.83,214.91,214.91,0,0,0-35.69,20.09c-9.24,6.23-17.21,11.61-33.19,16.24A146.13,146.13,0,0,1,958.82,4197.11Z';
    
    gsap.set(this.svg.presse.$group.find('#Haare path:last'), {
      display: 'none'
    });
    gsap.set(this.svg.presse.$haare, {
      stroke: OAX.style.theme_color.base_1.hex,
      strokeWidth : 15
    });

    tlPresseFrauHaareMaster.to(this.svg.presse.$haare, 5, {
      transformOrigin : '50% 50%',
      morphSVG : { 
        shape : toPath,
        // shapeIndex : 10
      },
      ease : 'Power1.easeInOut'
    });

    return tlPresseFrauHaareMaster;
  },

  animatePresseSchild : function(){
    this.svg.presse.$schild = this.svg.presse.$group.find('#Schild_an');
    this.svg.presse.$text = jQuery(this.container).find('.v-service__section:last');

    const tlSchildMaster = gsap.timeline({
      force3D : true,
      repeat : -1,
      yoyo: true
    });
    const rotation = -7;

    gsap.set([this.svg.presse.$schild], {
      transformOrigin: 'center top'
    });
    gsap.set(this.svg.presse.$text, {
      rotation : 6
    });

    tlSchildMaster.to(this.svg.presse.$schild, 5, {
      rotation : rotation,
      ease : 'Power1.easeInOut'
    }, 0).to(this.svg.presse.$text, 5, {
      ease : 'Power1.easeInOut',
      x : 28,
      rotation : -1
    }, 0);

    return tlSchildMaster;
  }
};

export default ServiceSVGAnimation;
